document.addEventListener('turbolinks:load', () => {
  if (document.body.id == 'controller-name-action-name-2') {
    
  }
})